export default __webpack_public_path__ + "static/media/baila4.abd75a30.png";